import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import ContentWrapper from '../../Layout/ContentWrapper';
import { Col, Row, Card, Button } from 'reactstrap';
import { useForm } from 'react-hook-form';
import InsertApplicantBody from './insertApplicantBody';
import ApplicantExistsCheck from './applicantExistsCheck';
import { createOrUpdateApplicantByRecruiter } from '../Services/applicantService';
import { useHistory } from 'react-router-dom';
import { SpinnerLoader } from '../Components/shared/spinnerLoader';

const InsertApplicant = ({ applicant, closeModal, refreshApplicant }) => {
  const { handleSubmit, reset, control, setValue, watch } = useForm({});
  const { t } = useTranslation();
  const history = useHistory();
  const [applicantAlreadyExistsChecked, setApplicantAlreadyExistsChecked] = useState(applicant ? true : false);
  const [email, setEmail] = useState();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmitWithValidations = (values) => {
    setIsLoading(true);

    createOrUpdateApplicantByRecruiter(values)
      .then((result) => {
        history.push(`/applications/details?applicantId=${result.data}&tab=applicationDetails`);
        closeModal && closeModal();
        refreshApplicant && refreshApplicant();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const onError = (errors) => {
    const firstErrorKey = Object.keys(errors)[0];
    const errorElement = document.querySelector(`[name="${firstErrorKey}"]`);
    if (errorElement && typeof errorElement.focus === 'function') {
      errorElement.focus();
    } else {
      console.error(`Element with name "${firstErrorKey}" not found or cannot be focused.`);
    }
  };

  const header = () => {
    return (
      <div className="content-heading">
        <Col md={10}>
          {t('applicant.INSERT_APPLICANT')}
          &nbsp;
          <small>{t('dashboard.WELCOME_BETA')}</small>
        </Col>
      </div>
    );
  };

  return (
    <ContentWrapper>
      {header()}
      <Row className="justify-content-center" style={{ minHeight: '100vh' }}>
        <Col md={7}>
          <Card className="card card-default">
            <div className="card-header h3 m-0 mt-3 text-center">
              {applicantAlreadyExistsChecked ? t('common.CONTACT_INFO') : t('applicants.CHECK_IF_APPLICANT_EXISTS')}
            </div>
            {applicantAlreadyExistsChecked ? (
              <form onSubmit={handleSubmit(handleSubmitWithValidations, onError)}>
                <div className="card-body">
                  <InsertApplicantBody control={control} setValue={setValue} email={email} applicant={applicant} />
                </div>
                <div className="card-footer">
                  <Row>
                    <Col>
                      {isLoading ? (
                        <SpinnerLoader />
                      ) : (
                        <div className="d-flex justify-content-between">
                          <Button color="primary" type="submit">
                            {t('applicants.SAVE_GO_TO_DETAILS')}
                          </Button>
                          <Button color="secondary" onClick={closeModal}>
                            {t('common.CANCEL')}
                          </Button>
                        </div>
                      )}
                    </Col>
                  </Row>
                </div>
              </form>
            ) : (
              <ApplicantExistsCheck
                setEmail={setEmail}
                setApplicantAlreadyExistsChecked={setApplicantAlreadyExistsChecked}
              />
            )}
          </Card>
        </Col>
      </Row>
    </ContentWrapper>
  );
};

export default InsertApplicant;
